export const StatusEnum = Object.freeze({
  PENDING: "PENDING",
  PARTIALLY_PROCESSED: "PARTIALLY_PROCESSED",
  FULLY_PROCESSED: "FULLY_PROCESSED",
});
